import { render, staticRenderFns } from "./EditEmployee.vue?vue&type=template&id=528de2c8"
import script from "./EditEmployee.vue?vue&type=script&lang=js"
export * from "./EditEmployee.vue?vue&type=script&lang=js"
import style0 from "./EditEmployee.vue?vue&type=style&index=0&id=528de2c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports